import clsx from 'clsx';
import { memo } from 'react';

type Props = {
    idle?: boolean;
}

export const SkeletonText = memo(({ idle }: Props) => (
    <p className={clsx({
        'vss-skeleton-text': true,
        'vss-skeleton-text--idle': idle,
    })}
    />
));
